module.exports = __webpack_public_path__ + "static/media/Maximus Pro-2x.ac620e67.jpeg";